import { render } from "./AppNavSettings.vue?vue&type=template&id=0c1ac0be&scoped=true"
import script from "./AppNavSettings.vue?vue&type=script&lang=js"
export * from "./AppNavSettings.vue?vue&type=script&lang=js"

import "./AppNavSettings.vue?vue&type=style&index=0&id=0c1ac0be&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1ac0be"]])

export default __exports__